import "./App.css";
import HomePage from "./Pages/HomePage";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
